import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../config/firebase';

/**
 * 이미지 파일을 Firebase Storage에 업로드하고 URL을 반환
 * @param {File} file - 업로드할 이미지 파일
 * @param {string} folder - Storage 폴더 경로 (예: 'observation', 'program')
 * @returns {Promise<string>} 업로드된 이미지 URL
 */
export const uploadImageToStorage = async (file, folder = 'markdown-images') => {
  try {
    // 파일 타입 검증
    if (!file.type.startsWith('image/')) {
      throw new Error('이미지 파일만 업로드 가능합니다.');
    }

    // 파일 크기 검증 (10MB)
    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      throw new Error('이미지 크기는 10MB 이하여야 합니다.');
    }

    // 고유한 파일명 생성
    const timestamp = Date.now();
    const randomStr = Math.random().toString(36).substring(2, 9);
    const ext = file.name.split('.').pop();
    const fileName = `${timestamp}_${randomStr}.${ext}`;

    // Firebase Storage에 업로드
    const storageRef = ref(storage, `${folder}/${fileName}`);
    const snapshot = await uploadBytes(storageRef, file);

    // 다운로드 URL 가져오기
    const downloadURL = await getDownloadURL(snapshot.ref);

    return downloadURL;
  } catch (error) {
    console.error('Image upload failed:', error);
    throw error;
  }
};

/**
 * 클립보드나 드롭 이벤트에서 이미지 파일 추출
 * @param {DataTransfer} dataTransfer - 클립보드 또는 드롭 이벤트의 dataTransfer
 * @returns {File|null} 이미지 파일 또는 null
 */
export const extractImageFromDataTransfer = (dataTransfer) => {
  const items = dataTransfer.items || dataTransfer.files;

  for (let i = 0; i < items.length; i++) {
    const item = items[i];

    // DataTransferItemList인 경우
    if (item.kind === 'file') {
      const file = item.getAsFile();
      if (file && file.type.startsWith('image/')) {
        return file;
      }
    }
    // FileList인 경우
    else if (item.type && item.type.startsWith('image/')) {
      return item;
    }
  }

  return null;
};
